var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatarAgent1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 88,
    viewBox: "0 0 89 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1385_8369",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 89,
    height: 88
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 44,
    r: 44,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1385_8369)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 44,
    r: 44,
    fill: "#D6E8F6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.9296 61.0888L90.1703 60.3483C89.5482 60.2888 88.9598 60.6422 88.7196 61.2193L82.8615 75.3135C82.4939 76.1982 83.0875 77.1857 84.0416 77.277L92.1153 78.0477C92.7484 78.1078 93.3447 77.742 93.5768 77.1507L99.1204 63.026C99.4658 62.1456 98.872 61.1792 97.9296 61.0888Z",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.1829 86.253C90.3194 86.3705 96.842 79.7059 100.325 76.0134L96.8362 73.8906L77.7869 85.8436L90.1829 86.253Z",
    fill: "#FFB27D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.0994 61.1579C52.8277 62.7329 49.9796 64.0317 46.4045 64.8563C33.0037 67.951 27.8687 56.6302 25.9386 48.8592C27.7677 47.8139 29.4868 47.5835 30.4788 47.4651C31.4484 47.3509 32.4673 47.2751 33.3111 47.2333C34.8148 46.0812 37.0569 41.3662 37.5529 34.0459L38.1835 34.2148L48.7453 37.1041C48.7453 37.1041 48.2627 40.4597 48.0248 43.6316C47.8408 46.1133 47.8116 48.4853 48.2829 49.0656C49.1066 49.2442 49.6026 49.361 49.6026 49.361C49.6026 49.361 49.6026 49.3646 49.6071 49.3709C49.7485 49.6033 52.8142 54.6398 55.0994 61.1579Z",
    fill: "#EFD1B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.7451 37.1056C48.7451 37.1056 48.2603 40.4586 48.0247 43.6332C42.0414 43.0342 39.2652 37.3403 38.1834 34.2168L48.7451 37.1056Z",
    fill: "#D7AE88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5323 40.2567C50.5323 40.2567 36.3303 39.4736 36.9542 30.6407C37.5781 21.808 36.1664 15.758 45.2604 15.8848C54.3552 16.0113 55.8769 19.506 56.3861 22.5047C56.8951 25.5039 54.2439 40.2331 50.5323 40.2567Z",
    fill: "#EFD1B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0694 34.6849C35.5917 27.4991 31.8843 22.0733 33.0472 19.0762C34.2102 16.0792 37.2684 15.7815 37.2684 15.7815C37.2684 15.7815 39.7486 9.86687 47.8935 12.0782C56.0385 14.2896 60.5603 18.5206 57.1944 25.7538C55.1862 25.4406 52.8752 24.3362 49.3289 25.0577C47.641 25.401 46.4737 28.3747 46.4737 28.3747L44.9588 28.1384C44.9588 28.1384 43.3237 24.1384 41.0289 24.7731C38.7341 25.4078 39.32 29.3288 39.32 29.3288L37.681 34.9363L36.0694 34.6849Z",
    fill: "#312C36"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.8322 48.6515C52.8322 48.6515 29.6933 43.0369 19.6343 51.3303L27.5598 86.3718L24.6616 121.415L69.9116 110.489C69.9116 110.489 68.6384 106.054 59.9615 94.2613C51.2836 82.4687 55.0588 65.171 52.8322 48.6515Z",
    fill: "#EFD1B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5151 71.3196C17.6305 79.7509 22.0989 90.0684 23.6947 95.6224L23.5757 120.197C23.5757 120.197 24.2221 121.224 24.6619 121.414C34.097 125.522 57.5481 105.906 57.5481 105.906C57.5481 105.906 58.3964 90.2384 57.5481 88.4015C57.1955 87.6415 56.8209 85.178 58.5275 80.0724C60.9473 87.5286 65.416 96.1383 69.9113 97.6067C74.851 99.2223 94.3837 84.6741 94.3837 84.6741C94.3837 84.6741 94.4964 82.9069 92.0272 81.2355C90.4394 80.1605 86.7924 79.7983 86.7924 79.7983L74.3021 85.3848C72.7347 82.7041 68.8293 64.1581 64.4693 55.7864C61.191 49.4931 52.4376 48.5814 52.4376 48.5814C52.4376 48.5814 48.795 54.3568 39.9839 53.5376C31.1749 52.7186 29.5635 47.3281 29.5635 47.3281C29.5635 47.3281 21.7488 48.3663 19.3429 50.3078C18.9255 50.6445 15.0496 60.2733 16.5151 71.3196Z",
    fill: "#4B81AC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.22303 79.2553C6.22303 79.2553 -11.808 86.5868 -15.1189 91.4397C-8.69509 95.6687 2.23135 99.7056 10.9417 91.528C23.5965 79.6477 23.6801 60.8862 23.6801 60.8862C16.936 66.0678 10.2351 75.0963 6.22303 79.2553Z",
    fill: "#2F6086"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.6197 61.2425L91.8602 60.5016C91.2381 60.4423 90.6494 60.7957 90.4097 61.3728L84.5513 75.4672C84.1837 76.3515 84.7771 77.3394 85.7312 77.4302L93.8051 78.2012C94.4382 78.2616 95.0345 77.8955 95.2668 77.3037L100.81 63.1797C101.156 62.2988 100.562 61.3322 99.6197 61.2425Z",
    fill: "#2B478B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0353 62.0845L30.1548 55.1621L19.7135 91.0705L43.594 97.9928L54.0353 62.0845Z",
    fill: "#413D45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2141 82.6519C47.2141 82.6519 49.6064 82.5879 50.3417 82.4845C51.077 82.3811 50.5885 83.9023 49.7424 84.1928C48.8912 84.4783 47.2141 82.6519 47.2141 82.6519Z",
    fill: "#EFD1B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9235 92.791C49.9235 92.791 48.9026 93.0146 48.3995 92.9162C48.3995 92.9162 47.5068 92.6702 46.8558 92.5316C46.6486 92.4869 46.4711 92.4556 46.3527 92.4422C45.8546 92.3975 44.7498 92.4332 43.5907 92.0219C42.4317 91.6105 38.4958 89.7816 38.4958 89.7816L39.6204 86.4681L40.4687 83.8432C40.4687 83.8432 47.1172 82.2379 48.2466 82.5107C48.3551 82.5375 48.4636 82.5688 48.5623 82.6046C49.4944 82.9176 50.0419 83.5034 50.5105 83.718C50.6831 83.7985 52.3255 84.6929 52.4143 85.2071C52.5326 85.9225 52.2959 86.4591 51.8915 86.79C51.8915 86.79 52.0591 88.1986 51.4821 88.9946C51.4821 88.9946 51.6843 90.2869 50.6535 91.0962C50.6584 91.0962 50.6979 92.4288 49.9235 92.791Z",
    fill: "#EFD1B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.089 53.5386C18.2131 48.6748 29.5628 47.3291 29.5628 47.3291L24.948 56.2756L25.7351 57.2515C25.7351 57.2515 23.1176 62.9669 17.678 72.4602L17.3069 74.0593C17.6891 74.3377 18.4026 74.8102 19.6285 75.4753C25.7259 78.0621 41.1107 83.5546 41.1107 83.5546C41.4016 83.7223 41.6013 83.9391 41.7195 84.1986C41.8043 84.2264 41.8894 84.2542 41.9748 84.282C41.9748 84.282 42.2923 88.7879 38.9304 92.9413C38.9304 92.9413 38.1958 92.7075 36.9567 92.312C31.9421 97.6103 24.8759 103.239 24.8759 103.239C2.6425 84.0724 2.25917 81.0057 2.25917 81.0057C1.95843 74.8335 11.139 59.6886 15.089 53.5386Z",
    fill: "#3D83BB"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarAgent1);
export default __webpack_public_path__ + "static/media/avatar_agent_1.7f430f32c95965cc01d21cb37e1d81ce.svg";
export { ForwardRef as ReactComponent };